import { render, staticRenderFns } from "./ContentEditSale.vue?vue&type=template&id=2b32f129&"
import script from "./ContentEditSale.vue?vue&type=script&lang=js&"
export * from "./ContentEditSale.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditSale.vue?vue&type=style&index=0&id=2b32f129&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports